import * as React from 'react';
import { getIconClassName } from '@uifabric/styling/lib/index';

export interface TreeRootNodeProps {
    rootDisplayName: string;
    rootIconName?: string;
    onRootNodeClicked?: () => void;
    isRootExpanded?: boolean;
    onKeyDown?: (e: any) => void;
    refValue?: React.RefObject<any>;
}

const classNames = require('classnames/bind');
const styles = require('./TreeNode.scss');

/**
 * Component which renders root node of the tree
 * @param props TreeRootNodeProps
 */
const TreeRootNode = (props: TreeRootNodeProps) => {
    const {
        rootDisplayName,
        onRootNodeClicked,
        rootIconName,
        isRootExpanded,
        refValue,
        onKeyDown,
    } = props;

    const rootNodeProps = onRootNodeClicked
        ? {
              role: 'button',
              tabIndex: 0,
              ref: refValue,
              onKeyDown: onKeyDown,
              onClick: onRootNodeClicked,
              'aria-expanded': !!isRootExpanded,
          }
        : { role: 'heading' };

    return (
        <div
            tabIndex={-1}
            className={styles.rootNodeContainer}
            {...rootNodeProps}
            data-testid={rootDisplayName}>
            {rootIconName && (
                <i className={classNames('ms-Icon', getIconClassName(rootIconName), styles.icon)} />
            )}
            {rootDisplayName}
        </div>
    );
};

export default TreeRootNode;
